import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild,} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSelect} from '@angular/material/select';
import {MatSelectFilterComponent} from 'mat-select-filter';
import {Acheteur} from 'src/app/domain';
import {CriteriaSearch} from 'src/app/domain/search/CriteriaSearch';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {hasrequiredField} from 'src/app/utils/Hasrequired';
import { Router } from '@angular/router';

@Component({
    selector: 'app-combo-acheteur',
    templateUrl: './combo-acheteur.component.html',
    styleUrls: ['./combo-acheteur.component.css']
})
export class ComboAcheteurComponent implements OnInit, AfterViewInit {

    @Input() control: FormControl;
    selectedItem: any;
    @Input() label = 'test';
    searchObject: SearchObject = new SearchObject();
    @Input() isSupp:boolean = false;
    list: Acheteur[] = [];
    listsearch: Acheteur[] = [];
    isLoading = false;
    required = hasrequiredField;
    @ViewChild('MatSelect') select: MatSelect;
    @Output() object = new EventEmitter<any>();
    @Input() muliple = false;
    @ViewChild(MatSelectFilterComponent) filter: MatSelectFilterComponent;

    constructor(
        private offerservice: AppeloffreService,public router: Router,
        private appTranslateService: AppTranslateService,
        private toastService: ToastService, private searchObjectService: SearchObjectService
    ) {
    }

    get isReady() {
        return Array.isArray(this.list);
    }

    ngOnInit(): void {
        this.fetchlist();
    }

    change(e) {

        this.filter?.searchForm.reset();
        // this.filter.filteredReturn.emit(this.options)
        // this.filter.input=""
    }

    changeValue(value: any) {

        if (this.getlang() == 'ar') {
            this.selectedItem = this.list.filter((item) => item.instNmAr == value)[0];

            this.object.emit(this.selectedItem);
        } else if (this.getlang() == 'fr') {
            this.selectedItem = this.list.filter((item) => item.instNm == value)[0];

            this.object.emit(this.selectedItem);
        } else if (this.getlang() == 'en') {
            this.selectedItem = this.list.filter((item) => item.instNmEn == value)[0];

            this.object.emit(this.selectedItem);
        }
    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    clear($event: MouseEvent) {
        $event.stopPropagation();
        this.control.setValue(undefined);
    }

    ngAfterViewInit(): void {
        this.fetchlist();
    }

    private fetchlist() {
        this.isLoading = true;

        this.searchObject.listCol = ['instRegNo', 'instNm', 'instNmAr'];

        ;
        this.searchObject.dataSearch.push(new CriteriaSearch(
                'delFl',
                'Y' || undefined,
                '!='
            ),
        );
      if(this.router.url.includes('fournisseur')){
            this.offerservice.getAcheteurListF(this.searchObject).subscribe({
                next: (response) => {
    
                    this.list = response['payload']['data'];
    
                    this.listsearch = response.payload.data;
    
                    this.listsearch?.map(
                        (item) => (item.motcle = item.instNmAr + '' + item.instNm)
                    );
                },
                error: (e) => {
                    this.toastService.error();
    
                    this.isLoading = false;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        }
        else {
            this.offerservice.getAcheteurList(this.searchObject).subscribe({
                next: (response) => {
    
                    this.list = response['payload']['data'];
    
                    this.listsearch = response.payload.data;
    
                    this.listsearch?.map(
                        (item) => (item.motcle = item.instNmAr + '' + item.instNm)
                    );
                },
                error: (e) => {
                    this.toastService.error();
    
                    this.isLoading = false;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        }
    }
}
